<template>
  <div class="row g-2 mt-0">
    <div class="col-sm-12 col-lg-3 align-self-start">
      <div class="row g-2">
        <div class="col-12">
          <RunningOrderNote
            v-if="bomStore.runningOrder"
            :on-hold-url="bomStore.runningOrder.putOnHoldUrl"
          />
          <AssemblyImpactNote v-else />
        </div>

        <div class="col-12" v-if="!bomStore.pricesOutdated && bomStore.quantityPrice">
          <PriceTable />
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-lg-9 d-flex flex-column">
      <Guide class="mb-2" />

      <PartAssignment v-if="assignStore.active" />
      <BomPartTable v-show="showTable" class="mb-3" />
    </div>
  </div>
</template>

<script>
import { useBomStore, useAssignStore } from 'store/bom';
import PartAssignment from './assignment/PartAssignment.vue';
import BomPartTable from './BomPartTable.vue';
import PriceTable from './PriceTable.vue';
import Guide from './Guide.vue';
import AssemblyImpactNote from './AssemblyImpactNote.vue';
import RunningOrderNote from './RunningOrderNote.vue';

export default {
  name: 'BomEditor',
  props: {
    dataPath: String,
  },
  components: {
    RunningOrderNote,
    PartAssignment,
    AssemblyImpactNote,
    BomPartTable,
    PriceTable,
    Guide,
  },
  setup() {
    const bomStore = useBomStore();
    const assignStore = useAssignStore();
    return { bomStore, assignStore };
  },
  computed: {
    showTable() {
      return !this.assignStore.active && !this.bomStore.error;
    },
  },
  async created() {
    await this.bomStore.fetchBom();
    if (this.bomStore.areJobsRunning) {
      await this.bomStore.waitForJobCompletion(true);
      await this.bomStore.fetchBom();
      await this.bomStore.waitForJobCompletion();
    }
  },
};
</script>
